<div class="container flex flex-col gap-3 my-3">
  <div class="text-view">{{ title }}</div>
  <div class="font-bold overflow-hidden text-ellipsis whitespace-nowrap w-full">
    {{ data }} @if (!data) {
    <div class="italic font-normal">
      {{ "manage_location.shared.empty" | transloco }}
    </div>
    }
  </div>
  <hr class="my-3" />
</div>
